import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchDepartments: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'department/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_DEPARTMENT_REQUEST,
                        types.SEARCH_DEPARTMENT_SUCCESS,
                        types.SEARCH_DEPARTMENT_FAILURE
                    ]
                }
            });
        },
    loadDepartment: (id) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'department/' + id,
                    method: 'GET',
                    types: [
                        types.LOAD_DEPARTMENT_REQUEST,
                        types.LOAD_DEPARTMENT_SUCCESS,
                        types.LOAD_DEPARTMENT_FAILURE
                    ]
                }
            })
        }
    },
    saveDepartment: (department) =>
        (dispatch) => {
            if (department.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'department/create',
                        method: 'POST',
                        body: department,
                        types: [
                            types.CREATE_DEPARTMENT_REQUEST,
                            types.CREATE_DEPARTMENT_SUCCESS,
                            types.CREATE_DEPARTMENT_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'department/update',
                        method: 'PUT',
                        body: department,
                        types: [
                            types.UPDATE_DEPARTMENT_REQUEST,
                            types.UPDATE_DEPARTMENT_SUCCESS,
                            types.UPDATE_DEPARTMENT_FAILURE
                        ]
                    }
                });
            }
        }
}
